import { render, staticRenderFns } from "./LegacyGrid.vue?vue&type=template&id=16dbfda6&scoped=true&lang=html&"
import script from "./LegacyGrid.vue?vue&type=script&lang=js&"
export * from "./LegacyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dbfda6",
  null
  
)

export default component.exports